import React, { forwardRef } from 'react';
// import Picture from '@components/Picture';
import { Picture } from '@ui';
import clsx from 'clsx';
import './index.scss';
import { twcls } from '@utils/twcls';
import icons from '@icons';

const {
  checkmark: { white: checkmarkWhiteOutlined }
} = icons.Outline;

interface ChackBoxProps {
  className?: string;
  isChecked?: boolean;
  onClick?: (e) => void;
  isRoundCheckbox?: boolean;
  disabled?: boolean;
  title?: string;
}

const CheckBox = forwardRef<HTMLDivElement, ChackBoxProps>(
  (
    {
      className,
      isChecked,
      onClick,
      isRoundCheckbox,
      disabled = false,
      title,
      ...props
    },
    ref
  ) => (
    <div
      ref={ref}
      onClick={!disabled ? onClick : undefined}
      {...props}
      className={twcls('flex items-center cursor-pointer', className)}
    >
      <div
        className={clsx(
          `CheckBox`,
          isChecked && 'CheckBox--checked',
          isRoundCheckbox && 'CheckBox--round',
          disabled && 'CheckBox--disabled'
        )}
      >
        {isRoundCheckbox && <div className='CheckBox__circle' />}
        {!isRoundCheckbox && isChecked && (
          <Picture
            icon={checkmarkWhiteOutlined.x3}
            height='14'
            width='14'
            pictureClassName='flex-shrink-0'
          />
        )}
      </div>

      {title && <span className='ml-2'>{title}</span>}
    </div>
  )
);

export default CheckBox;
